import { DrugModel } from '@/models/drug';

export enum StockItemStatus {
  Available = 'available',
  PossiblyUsed = 'possibly_used',
  Returned = 'returned',
}

export interface StockItemStatsModel {
  $drugId: string;
  $centerId: string;
  $drug?: DrugModel;
  lotId?: string;
  counters: {[key: string]: number};
}

export interface StockBatchStatusUpdateModel {
  $drugId: string;
  $patientId: string;
  lotId?: string;
  statusFrom: StockItemStatus;
  statusInto?: StockItemStatus;
  isStorno?: boolean;
  amount: number;
}

export interface StockCreationModel {
  $drugId: string;
  $patientId: string;
  lotId?: string;
  amount: number;
  $expiredAt?: string;
}

export interface StockItemModel {
  $id?: string;
  lotId?: string;
  $patientId?: string;
  $centerId?: string;
  $drugId?: string;
  $drug?: DrugModel;
  status: StockItemStatus;
  $createdAt?: Date;
  $updatedAt?: Date;
  $expiredAt?: Date;
  $possiblyUsedAt?: Date;
  $returnedAt?: Date;
}
